export default class LogPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, document) {
        return this.gate.allow('read', 'document', document);
    }

    add(user, document) {
        return this.gate.allow('edit', 'document', document);
    }
}
